<div class="evir-resources-panel" role="main" aria-label="EVIR Settings">
	<div class="header-row">
		<h1 class="heading-1 page-title">
			{{ "EVIR Settings" | i18next: { format: "capitalize" } }}
		</h1>
	</div>

	<p style="margin-left: 40px;" class="heading-4">View the <a routerLink="/mir-rules">Missing Inspection Rules
			report</a> to create and edit new rules for your assets.</p>

	<div class="panel-main-row">
		<!-- Default asset type  -->
		<div class="panel-col">
			<mat-card>
				<div class="layout asset-layout">
					<h2 class="heading-4 card-title">
						{{ "default asset type for EVIR Mobile" | i18next: { format: "capitalize" } }}
					</h2>
					<div class="setting-description" id="asset-type-description">
						{{
						"please choose which asset type should be the default for all future inspections"
						| i18next: { format: "capitalize" }
						}}
					</div>

					<div class="content">
						<mat-radio-group [value]="selectedAssetType" (change)="handleAssetTypeChange($event)"
							class="radio-group" #radioGroup (keydown)="onAssetTypeRadioKeydown($event)"
							aria-describedby="asset-type-description"
							[attr.aria-label]="'default asset type for EVIR Mobile' | i18next: { format: 'capitalize' }">
							<mat-radio-button *ngFor="let type of assetTypes; trackBy: trackAssetTypeValue"
								[value]="type.value" class="radio-btns">
								{{ type.label }}
							</mat-radio-button>
						</mat-radio-group>

						<div [innerHTML]="assetTypeImage" role="img" aria-label="Asset type preview image"></div>
					</div>
				</div>
			</mat-card>
		</div>

		<!-- Inspection and image retention-->
		<div class="panel-col" *ngIf="showImageRetention">
			<mat-card>
				<div class="layout">
					<h2 class="heading-4 card-title">
						{{ "inspection and image retention" | i18next: { format: "capitalize" } }}
					</h2>
					<div class="setting-description" id="retention-description">
						{{
						"amount of time inspections and images will be kept on file."
						| i18next: { format: "capitalize" }
						}}
					</div>
					<!-- select -->
					<div class="outer">
						<mat-form-field appearance="outline">
							<mat-label>
								{{ "retain for number of years" | i18next: { format: "capitalize" } }}
							</mat-label>
							<mat-select #retentionTimeChangeSelect (selectionChange)="handleRetentionTimeChange($event)"
								[value]="selectedValue"
								aria-describedby="retention-description">
								<mat-option *ngFor="let option of options" [value]="option">
									{{ option }}
								</mat-option>
							</mat-select>
						</mat-form-field>
					</div>
				</div>
			</mat-card>
		</div>
	</div>
</div>
